import React from 'react';
import { Node } from '@uncinc/react-drupal-core';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { NodeEvent } from '../../../../types/nodes';

type Props = {
  entities: Immutable.List<ImmutableEntity<NodeEvent>>,
  cta: React.ReactNode,
};

const HighlightedEvents = ({ entities, cta }: Props) => {
  if (entities.size > 1 && cta) {
    return cta;
  }

  return (
    <div className="HighlightedEvents">
      {entities.map((entity) => {
        const uuid = entity.getIn(['uuid', 0, 'value']);
        const langcode = entity.getIn(['langcode', 0, 'value']);

        return (
          <div key={`${uuid}:${langcode}`}>
            <Node
              key={`${uuid}:${langcode}`}
              entity={entity}
              viewMode="teaser"
              withBackground
            />
          </div>
        );
      })}
    </div>
  );
};

export default HighlightedEvents;
